// BoardStatsRow.tsx — Sprint 15. Four summary cards: active members,
// upcoming meetings, open votes, total resolutions.
import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import { BarChartOutlined, TeamOutlined } from '@ant-design/icons';

export interface BoardStatsRowProps {
  activeMembers:    number;
  upcomingMeetings: number;
  openVotes:        number;
  totalResolutions: number;
}

export const BoardStatsRow: React.FC<BoardStatsRowProps> = ({
  activeMembers, upcomingMeetings, openVotes, totalResolutions,
}) => (
  <Row gutter={16} style={{ marginBottom: 20 }}>
    <Col span={6}>
      <Card>
        <Statistic title="Board Members" value={activeMembers} prefix={<TeamOutlined />} />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic title="Upcoming Meetings" value={upcomingMeetings} valueStyle={{ color: '#1890ff' }} />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic
          title="Open Votes" value={openVotes}
          valueStyle={{ color: openVotes > 0 ? '#fa8c16' : '#52c41a' }}
        />
      </Card>
    </Col>
    <Col span={6}>
      <Card>
        <Statistic title="Total Resolutions" value={totalResolutions} prefix={<BarChartOutlined />} />
      </Card>
    </Col>
  </Row>
);
